import { useNavigate } from "react-router-dom";

//Material-UI
import { Grid, Typography, Button } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

//Components
import { utils } from "../../../utils/utils";
import Spinner from "../../../components/spinner";
import StockControlDetailsTable from "./table";
import ChipState from "../../../components/ChipState";
import { Box, FormControll } from '@arredo/reactjs-ui';

//Hooks
import useStockControl from "../../../hooks/stockControls/useStockControl";

//Other
import useStyles from './styles';
import { stockControlStatesFormat } from "../../../models/StockControlEntity";
import { typesFilter, statesFilter } from '../../../models/MovementEntity';

const StockControlView = ({ warehouseId, stockControlId, branchCode }) => {
    const { classes } = useStyles();
    const { stockControl, loading } = useStockControl(warehouseId, Number(stockControlId) || null, branchCode);
    const push = useNavigate();
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={6}>
                    <Box
                        header={
                            loading
                                ? <Spinner message='Cargando' />
                                : <div>
                                    <Grid className={classes.gridTitle} size={12}>
                                        <Typography variant="h6">Información</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">Control de stock n°: {stockControl?.id}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">
                                            Estado: <ChipState size="small" state={stockControl?.state} label={stockControlStatesFormat[stockControl?.state]} />
                                        </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">Productos: {stockControl?.details?.length || 0}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">Movimientos: {stockControl?.movements?.length || 0}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">Fecha de creación: {utils.formatDate(stockControl?.created)}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1">Ultima modificación: {stockControl?.updated ? utils.formatDate(stockControl?.updated) : "-"}</Typography>
                                    </Grid>
                                </div>
                        }
                    />

                </Grid>

                <Grid size={6}>
                    <Box header={
                        loading
                            ? <Spinner message='Cargando' />
                            : <div>
                                <Grid className={classes.gridTitle} size={12}>
                                    <Typography variant="h6">Movimientos</Typography>
                                </Grid>
                                {stockControl?.movements?.length > 0
                                    ? <Grid container spacing={2}>
                                        {

                                            stockControl?.movements?.map((item, index) => (
                                                <Grid key={index} size={6}>
                                                    <Grid>
                                                        <FormControll label='Id' value={item.movementId} />
                                                        <FormControll label='Estado' value={statesFilter[item.state]} />
                                                        <FormControll label='Tipo' value={typesFilter[item.type]} />
                                                        <FormControll label='Motivo' value={item.reason} />
                                                    </Grid>
                                                    <Button
                                                        variant='outlined'
                                                        onClick={() => push(`/movements/detail/${item?.movementId}`, { from: `/stockControls/${stockControlId}` })}
                                                        startIcon={<VisibilityIcon />}
                                                        className={classes.button}
                                                    >
                                                        Ver Movimiento
                                                    </Button>
                                                </Grid>

                                            ))
                                        }
                                    </Grid>
                                    : <>El control de stock no realizo ningún tipo de ajuste</>}
                            </div>
                    }
                    />
                </Grid>
            </Grid>
            <Grid item size={12} pt={2}>
                <Box header={
                    <Grid className={classes.gridTitle} size={12}>
                        <Typography variant="h6">Detalle</Typography>
                    </Grid>
                }
                >
                    <Grid container>
                        <Grid size={12}>
                            <StockControlDetailsTable
                                loading={loading}
                                details={stockControl.details}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </>
    );
}

export default StockControlView;
